import {IFreeMetaTransactions} from '../models/FreeMetaTransactions';

export const FETCH_FREE_META_TRANSACTIONS = 'FETCH_FREE_META_TRANSACTIONS';
export const FETCH_FREE_META_TRANSACTIONS_SUCCESS =
  'FETCH_FREE_META_TRANSACTIONS_SUCCESS';
export const FETCH_FREE_META_TRANSACTIONS_ERROR =
  'FETCH_FREE_META_TRANSACTIONS_ERROR';

export interface FetchFreeMetaTransactions {
  type: typeof FETCH_FREE_META_TRANSACTIONS;
}

export interface FetchFreeMetaTransactionsSuccess {
  type: typeof FETCH_FREE_META_TRANSACTIONS_SUCCESS;
  payload: IFreeMetaTransactions;
}

export interface FetchFreeMetaTransactionsError {
  type: typeof FETCH_FREE_META_TRANSACTIONS_ERROR;
}

export type FreeMetaTransactionsActionTypes =
  | FetchFreeMetaTransactions
  | FetchFreeMetaTransactionsSuccess
  | FetchFreeMetaTransactionsError;
